import React, { Component, ComponentType } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../redux/reducers';
import { roles, Role } from '../settings';

// info - interfejs, o który powinny być rozszerzane propsy komponentu komponowanego z poniższym HOC
export interface WithAccessProviderProps {
  checkAccess: (accessName: string) => boolean;
  findRole: () => Role;
}

type MapStateToProps = ReturnType<typeof mapStateToProps>;
type ComponentProps = DynamicTabComponent;

type AccessProviderProps = ComponentProps & MapStateToProps;

/**
 * Higher Order Component odpowiedzialny za dostarczanie informacji o tym, czy istnieje dostęp dla aktywnej roli do danej funkcjonalności.
 *
 * @param Cmp
 */
function withAccessProvider<P extends ComponentProps>(Cmp: ComponentType<P>) {
  class Controller extends Component<AccessProviderProps> {
    /**
     * findRole - sprawdza rolę użytkownika
     *
     * @memberof Controller
     */
    findRole = (): Role => {
      for (const roleObj in roles) {
        if (roles[roleObj].id === this.props.role) {
          return roles[roleObj];
        }
      }
      return {} as Role;
    };

    /**
     * checkAccess - sprawdza, czy użytkownik ma dostęp do zakładki
     *
     * @param {string} accessName
     * @returns boolean
     * @memberof Controller
     */
    checkAccess = (accessName: string): boolean => {
      const currentRole = this.findRole();
      return currentRole && currentRole.accessList ? !!currentRole.accessList.find(name => name === accessName) : false;
    };
    render(): React.ReactElement {
      const { role, userId, ...rest } = this.props;
      return <Cmp {...(rest as P)} checkAccess={this.checkAccess} findRole={this.findRole} />;
    }
  }
  return connect(mapStateToProps)(Controller);
}
const mapStateToProps = (state: RootState) => ({
  role: state.Auth.user.role,
  userId: state.Auth.user.id,
});
export default withAccessProvider;
